// action - account reducer
export const LOGIN = '@auth/LOGIN';
export const LOGOUT = '@auth/LOGOUT';
export const REGISTER = '@auth/REGISTER';
export const REQUIRES_2FA = 'REQUIRES_2FA';
export const INITIALIZED = 'INITIALIZED';
